module.exports = __webpack_public_path__ + "static/media/Resurs 140.cb6cdab4.png";